import { render, staticRenderFns } from "./Boletos.vue?vue&type=template&id=061d2320&scoped=true&"
import script from "./Boletos.vue?vue&type=script&lang=js&"
export * from "./Boletos.vue?vue&type=script&lang=js&"
import style0 from "./Boletos.vue?vue&type=style&index=0&id=061d2320&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061d2320",
  null
  
)

export default component.exports